import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function tableReservationAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isTableReservationPurchased']) {
    return next()
  }

  return next({ name: 'error-404' })
}

export default tableReservationAddonGuard
